import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import VideoServicesSection from '../components/home/VideoServicesSection';
import BenefitsSection from '../components/home/BenefitsSection';
import SponsorSection from '../components/home/SponsorSection';
import PartnersSection from '../components/home/PartnersSection';
import CTASection from '../components/home/CTASection';
import SEO from '../components/SEO';
import { seoData } from '../data/translations';

// Reusable Golden Glow Line Component
const GoldenGlowLine = () => (
  <div className="relative h-[2px] bg-black overflow-hidden">
    <div 
      className="absolute top-0 h-full w-[300px]"
      style={{
        background: 'linear-gradient(90deg, transparent, #D4AF37, #FFD700, #D4AF37, transparent)',
        animation: 'glowLine 4s ease-in-out infinite',
        boxShadow: '0 0 20px #D4AF37, 0 0 40px #D4AF37',
      }}
    />
  </div>
);

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#F9F9F9]">
      <SEO 
        title={seoData.home.title}
        description={seoData.home.description}
      />
      <Navbar />
      <main>
        <HeroSection />
        <VideoServicesSection />
        <GoldenGlowLine />
        <BenefitsSection />
        <GoldenGlowLine />
        <SponsorSection />
        <GoldenGlowLine />
        <PartnersSection />
        <GoldenGlowLine />
        <CTASection />
      </main>
      <Footer />
      
      {/* Glow Line Animation - Now in index.css */}
    </div>
  );
};

export default HomePage;
